export default __webpack_public_path__ + "static/media/time-check.d513454d.svg";